"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./BuySellChartIntervalSelectorComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('chart-interval-selector');
var BuySellChartIntervalSelectorComponent = function BuySellChartIntervalSelectorComponent(props) {
  var timeIntervals = [{
    label: '1H',
    seconds: 3600
  }, {
    label: '1D',
    seconds: 86400
  }, {
    label: '1W',
    seconds: 604800
  }, {
    label: '1M',
    seconds: 2678400
  }, {
    label: '1Y',
    seconds: 31536000
  }, {
    label: 'All',
    seconds: null
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, timeIntervals.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes('item'),
      key: item.label
    }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
      baseClass: classes('item'),
      customClass: item.seconds === props.currentInterval ? 'selected' : null,
      onClick: function onClick() {
        return props.changeTickersInterval(item.seconds);
      }
    }, item.label));
  }));
};
BuySellChartIntervalSelectorComponent.propTypes = {
  currentInterval: _propTypes["default"].number.isRequired,
  changeTickersInterval: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = BuySellChartIntervalSelectorComponent;